import React from 'react';
import styled from 'styled-components';
import Sugar from 'sugar';

import CustomerData, {CompanyName} from '../data/customerData';

import CustomerModal from './customerModal';
import {pxToEm} from './globalStyles';
import SectionDescription from './sectionDescription';

//#region Styled Components

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${pxToEm(35)}em 0 ${pxToEm(42)}em;
`;

const StyledSectionDescription = styled(SectionDescription)`
  margin-bottom: ${pxToEm(52)}em;
  text-align: center;
`;

const StyledCustomerModalsContainer = styled.div`
  display: flex;

  > *:not(:last-child) {
    margin-right: ${pxToEm(50)}em;
  }
`;

//#endregion

interface Props {
  companies: CompanyName[];
  headline: string;
  className?: string;
}

const WhoIsUsingSection: React.FunctionComponent<Props> = ({companies, headline, className}) => {
  const filtered = CustomerData.filter(customer => companies.indexOf(customer.name) !== -1);
  const customers = Sugar.Array.sortBy(filtered, customer => customer.name);

  return (
    <StyledWrapper>
      <StyledSectionDescription headline={headline} topSubHeadline="Showcase" />
      <StyledCustomerModalsContainer className={className}>
        {customers.map((customer, customerIndex) => (
          <CustomerModal key={`customer-modal-${customerIndex}`} customer={customer} />
        ))}
      </StyledCustomerModalsContainer>
    </StyledWrapper>
  );
};

export default WhoIsUsingSection;
